import React, { useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import permanentlyDeleteDocument from "../../../api/permanentlyDeleteDocument";

const BulkPermanentDeletePopup = ({
  setDocumentDeletedToTrue,
  Documentbulkid = [],
  bulkPermanentDeleteDocument,
  setBulkPermanentDeleteDocument,
  setRowSelection
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkPermanentDeleteDocument(false);
  };

  const onBulkPermanentDelete = async (Documentbulkid) => {
    const permanentDeleteAllDocumentFormResponse = await permanentlyDeleteDocument({
      token: token,
      id: Documentbulkid,
    });

    if (permanentDeleteAllDocumentFormResponse.code === 200) {
      setRowSelection({});
      setBulkPermanentDeleteDocument(false);
      setDocumentDeletedToTrue();
      showSuccess("Document/s deleted permanently");
    } else {
      showError("Error while bulk deleting document/s permanently");
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={bulkPermanentDeleteDocument}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <MdDelete />
          </div>
          <div className="popup-header-title">Permanently Delete Document</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to permanently delete these documents ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{ marginTop: "15px" }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{ marginTop: "15px" }}
            autoFocus={true}
            onClickFunc={() => {
              onBulkPermanentDelete(Documentbulkid);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BulkPermanentDeletePopup;
